module.exports = {"contactHead":"Contact us","email":"E-mail: info@horsesport.ge","tel":"","address":"","fb":"","instagram":"","twitter":"","youtubeCH":""}


//////////////////
// WEBPACK FOOTER
// ./src/components/EN-vers/menu/Contact.json
// module id = 92Dr
// module chunks = 0